module.exports = __webpack_public_path__ + "img/ddecs.711a2b4b.png";